.vc-fpt-preview * {
    pointer-events: none;
}
